import { Observable } from 'rxjs';

export interface ApiResponse {
  code: number,
  message: any
}

export abstract class MfoPapData {
  abstract get(param: any): Observable<ApiResponse>;
}
